module.exports = __webpack_public_path__ + "media/public/img/viator-review-widget-02-b1ddaf55601ef47b01cb5467e4120da7.svg";